export default __webpack_public_path__ + "static/klimadao-2a5310f77bd1e9cd73cf2b7856781ce3.jpg";